import MainHeader from "../../components/layout/MainHeader";
import PageHeader from "../../components/layout/PageHeader";
import Footer from "../../components/layout/Footer";
import img from "../../assets/images/background/13a.jpg";
import proImg from "../../assets/images/products/service-9.jpg";
import certificatImg1 from "../../assets/images/quality/certifications/5.png";
import certificatImg2 from "../../assets/images/quality/certifications/6.png";
import certificatImg3 from "../../assets/images/quality/certifications/7.png";
import certificatImg4 from "../../assets/images/quality/certifications/8.png";
import certificatImg5 from "../../assets/images/quality/certifications/9.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const certs = [certificatImg1, certificatImg2, certificatImg3, certificatImg4, certificatImg5];

function Accreditation() {
  const { t } = useTranslation();

  return (
    <>
      <MainHeader />
      <PageHeader image={img} title={t("Accreditation & Approvals")} />

      <section className="cert-section">
        <div className="container">
          {/* Header row */}
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-4">
            <div>
              <span className="page-section-label">{t("Projects")}</span>
              <h2 className="inner-page-heading" style={{ marginBottom: 0 }}>
                {t("Product accreditation")}
              </h2>
            </div>
            <Link to="/certifications" className="cert-link-btn">
              <i className="bi bi-patch-check" />
              {t("Consulting engineering approvals")}
            </Link>
          </div>

          <p className="cert-intro">{t("accreditation-text")}</p>

          {/* Banner image */}
          <img
            src={proImg}
            alt="Accreditation"
            style={{
              width: "100%",
              height: "420px",
              objectFit: "cover",
              borderRadius: "16px",
              display: "block",
              marginBottom: "40px",
            }}
          />

          {/* Certificate grid */}
          <div className="cert-grid">
            {certs.map((src, i) => (
              <a
                key={i}
                href={src}
                target="_blank"
                rel="noreferrer"
                className="cert-card"
                aria-label={`Certificate ${i + 1}`}
              >
                <img src={src} alt={`Certificate ${i + 1}`} />
              </a>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Accreditation;
